var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 116.33 87.96"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.92 10.6l-9.12-9.17a4.87 4.87 0 00-6.87-.03L41.71 57.99l-24.2-24.33a4.87 4.87 0 00-6.87-.03l-9.2 9.11a4.838 4.838 0 00-.03 6.85l36.75 36.94a4.87 4.87 0 006.87.03l69.86-69.11c1.9-1.88 1.92-4.95.03-6.85z",
    fill: "#45ad4a"
  })));
}
export default SvgGreenTick;